import React from 'react'
import { Card, CardBody, CardTitle } from "reactstrap";
import Chart from "react-apexcharts";

const ChartHeat = ({ title = '', data, color })  => {
    const series = [
        {
            data: data
        }
    ]

    const options = {
        legend: {
            show: false
        },
        chart: {
            height: 350,
            type: 'treemap'
        },
        title: {
            text: title
        },
        colors: [
            color
        ]
    }

    return <Chart options={options} series={series} type="treemap" height={350} />
}
const CardChartHeat = ({ cardTitle, chartTitle, chartColor, graphicData }) => {


    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa fa-bar-chart"/> &nbsp; {cardTitle}
                <div className="float-right">
                </div>
            </CardTitle>
            <CardBody>
                <ChartHeat data={graphicData} title={chartTitle} color={chartColor}/>
            </CardBody>
        </Card>
    )
}

export {
    ChartHeat,
    CardChartHeat as default
}